import * as React from 'react'

function SvgCouponIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.333 15.466l1.733-10.4 10.4-1.733L29.332 17.2 17.199 29.332 3.333 15.466z"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <circle
        cx={10.777}
        cy={10.777}
        r={2.141}
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgCouponIcon
